import { get } from 'lodash';
import { PathologyValuePath } from '../DataMapper/type';

function ItemDotGrayComponent(props) {
  if (
    props.item &&
    ((props.item.showInSimple && props.isSimple) ||
      (props.item.showInComplex && !props.isSimple)) &&
    ((props.item.showInExpanded && props.isExpanded) ||
      (props.item.showInCollapsed && !props.isExpanded))
  ) {
    const pathologyValue = get(props.item, PathologyValuePath, '-');
    return (
      <>
        {props.item.cnt < 2 && (
          <div className="dotGray dot">
            <span className="badge-white">{pathologyValue}</span>
          </div>
        )}
        {props.item.cnt >= 2 && (
          <div className="dotGrayMed">{props.item.cnt}</div>
        )}
      </>
    );
  } else return null;
}

export { ItemDotGrayComponent };
